export default __webpack_public_path__ + "static/media/Aeonik-Light.de239574.woff";